var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "main" } },
    [
      _c("map-component"),
      _vm._v(" "),
      _c("zoombar-component"),
      _vm._v(" "),
      _c("language-switch-component"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "has-background-black-ter", attrs: { id: "statusbar" } },
        [
          _vm.$conf.mouseposition.enabled
            ? _c("mouse-position-component")
            : _vm._e(),
          _vm._v(" "),
          _vm.$conf.scaleline.enabled ? _c("scale-line-component") : _vm._e(),
          _vm._v(" "),
          _vm.$conf.copyrights.length
            ? _c("span", {
                staticClass: "copyrights",
                domProps: { innerHTML: _vm._s(_vm.copyrights) },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("sidebar-component"),
      _vm._v(" "),
      _vm.$conf.timebar.enabled
        ? _c("timebar-component", {
            attrs: {
              minDate: _vm.$conf.timebar.minDate,
              maxDate: _vm.$conf.timebar.maxDate,
              from: _vm.$conf.timebar.rangeMinDate,
              to: _vm.$conf.timebar.rangeMaxDate,
              value: _vm.$conf.timebar.rangeMaxDate,
              milestones: _vm.$conf.timebar.deadLines,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("layer-switcher-advanced-component", {
        attrs: {
          activeBaseLayer: _vm.checkedBaseLayer,
          activeOverlayLayer: _vm.checkedOverlayLayer,
          baseLayers: _vm.baseLayers,
          overlayLayers: _vm.overlayLayers,
          onBaseLayerChange: _vm.baseLayerChanged,
          onOverlayLayerChange: _vm.overlayLayerChanged,
        },
      }),
      _vm._v(" "),
      _c("comparison-panel-component"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }